class ProductBuyBar extends HTMLElement {
  constructor() {
    "use strict";
    super();

    let classes = { show: "show" };
    let mainProductForm = document.querySelector(".product-form");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // In view -> Hide bar
            this.classList.remove(classes.show);
          } else if (window.scrollY > 200) {
            // Out of view AND scrolled a little from top -> Show bar
            this.classList.add(classes.show);
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(mainProductForm);

    // This script is loaded in product-template.liquid --> Footer observer after DOM ready
    document.addEventListener("DOMContentLoaded", function () {
      let siteFooter = document.querySelector("footer.footer");
      if (!siteFooter) return;
      observer.observe(siteFooter);
    });
  }
}
customElements.define("product-buy-bar", ProductBuyBar);

class UpsellCard extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.image = this.querySelector('.card-media img');

    if (this.select) {
      this.select.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const newImgSrc = selectedOption.getAttribute('data-variant-img-src');
        if (newImgSrc) { this.updateImage(newImgSrc) }
      });
    }
  }

  updateImage(newImgSrc) {
    if (this.image) {
      this.image.src = newImgSrc;
    }
  }
}

customElements.define('upsell-card', UpsellCard);

// Product description read more functionality
document.addEventListener('DOMContentLoaded', function() {
  const descriptionWrappers = document.querySelectorAll('.product-description-wrapper');
  
  descriptionWrappers.forEach(wrapper => {
    const textElement = wrapper.querySelector('.product-description-text');
    const button = wrapper.querySelector('.product-description-read-more');
    
    if (textElement && button) {
      const truncateRows = parseInt(textElement.getAttribute('data-truncate-rows'));
      
      if (truncateRows > 0) {
        // Ensure button is visible initially
        button.classList.remove('hide');
        
        // Store original button text
        const readMoreText = button.textContent.trim();
        const readLessText = button.getAttribute('data-read-less') || 'Lue vähemmän';
        
        // Set up toggle click handler
        button.addEventListener('click', function() {
          const isExpanded = wrapper.getAttribute('data-expanded') === 'true';
          
          if (isExpanded) {
            // Collapse
            wrapper.setAttribute('data-expanded', 'false');
            this.setAttribute('aria-expanded', 'false');
            this.textContent = readMoreText;
          } else {
            // Expand
            wrapper.setAttribute('data-expanded', 'true');
            this.setAttribute('aria-expanded', 'true');
            this.textContent = readLessText;
          }
        });
        
        // Check if content is actually truncated after a delay to ensure layout is complete
        setTimeout(function() {
          // Get computed styles
          const computedStyle = window.getComputedStyle(textElement);
          const lineHeight = parseFloat(computedStyle.lineHeight) || parseFloat(computedStyle.fontSize) * 1.5;
          
          // Clone to measure full height without line-clamp
          const clone = textElement.cloneNode(true);
          clone.style.webkitLineClamp = 'unset';
          clone.style.lineClamp = 'unset';
          clone.style.overflow = 'visible';
          clone.style.position = 'absolute';
          clone.style.visibility = 'hidden';
          clone.style.height = 'auto';
          clone.style.display = 'block';
          clone.style.width = textElement.offsetWidth + 'px';
          clone.style.webkitBoxOrient = 'vertical';
          wrapper.appendChild(clone);
          
          const fullHeight = clone.scrollHeight;
          const currentHeight = textElement.scrollHeight;
          const maxHeight = lineHeight * truncateRows;
          
          wrapper.removeChild(clone);
          
          // Only hide button if content truly doesn't need truncation
          // Compare full height with expected max height, not current height
          if (fullHeight <= maxHeight) {
            button.classList.add('hide');
          } else {
            button.classList.remove('hide');
          }
        }, 300);
      }
    }
  });
});